export const addAccent = (vowel) =>
  ({
    "Æ": "Ǽ",
    "Œ": "Œ́",
    "A": "Á",
    "E": "É",
    "I": "Í",
    "O": "Ó",
    "U": "Ú",
    "Y": "Ý",
    "æ": "ǽ",
    "œ": "œ́",
    "a": "á",
    "e": "é",
    "i": "í",
    "o": "ó",
    "u": "ú",
    "y": "ý"
  }[vowel] || vowel);



// WEBPACK FOOTER //
// ./src/addAccent.js